
import React, { useState, useEffect } from "react";
import { Box, Typography, useTheme, IconButton, Stack, Tooltip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, Button } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { darken } from '@mui/material/styles';
import { useMsal, useAccount } from "@azure/msal-react";
import { fetchMachineData, patchMachineComment } from "../../../fetchers/machine";
import Popup from '../../../components/Popup';
import AxionControls from "../../../components/controls/AxionControls";
import Cron from "../../../components/cronGenerator";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/system";
import FormLabel from "@mui/material/FormLabel";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { FormattedMessage, useIntl } from "react-intl";
import messages from "./messages";
import Controls from "../../../components/controls/Controls";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import { tokens } from "../../../assets/theme";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { pushErrorMessage, pushNotification } from "../../../utils/notifications";
import {
	DataGridPro,
	GridLogicOperator,
	useGridApiRef,
	gridFilterModelSelector,
	GridToolbar,
} from "@mui/x-data-grid-pro";
import ActivePOUpdateDialog from "../../activeProductionOrders/components/activePOUpdateDialog";
import { reportProductionOrderInSystem, createProductionOrderInSystem, deleteProductionOrderInSystem, pauseProductionOrderInSystem } from "../../../fetchers/productionOrder";
import { fetchProductionItems } from "../../../fetchers/productionItems";
import { getProducedByOrderNo } from "../../../fetchers/productionOrder";
import ProductionOrderReport from "./ProductionOrderReport";
import ProductionOrderReportScrap from "./ProductionOrderReportScrap";
import { isFeatureEnabled } from "../../../hooks/useFeatureFlags";

import { getProductionOrders, setProductionOrderStatus } from "../../../fetchers/productionOrder";
import PlayCircleFilledOutlinedIcon from '@mui/icons-material/PlayCircleFilledOutlined';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';
import PauseCircleOutlineOutlinedIcon from '@mui/icons-material/PauseCircleOutlineOutlined';
import PlaylistAddOutlinedIcon from '@mui/icons-material/PlaylistAddOutlined';
import MoveToInboxOutlinedIcon from '@mui/icons-material/MoveToInboxOutlined';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';



export default function StartStopPO(props) {
	const { formatMessage } = useIntl();
	const { accounts } = useMsal();
	const account = useAccount(accounts[0]);
	const queryClient = useQueryClient();
	const [commentOrder, setCommentOrder] = useState(null);
	const [savingComment, setSavingComment] = useState(false);
	const { onStartStopPO, onClose, isLoading } = props;
	const [startStopPO, setStartStopPO] = useState({ startStopPO: "", })

	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	const [companyKey, setCompanyKey] = useLocalStorage("companyKey", 1);
	const [timeSpan, setTimeSpan] = useLocalStorage("timeSpan", 10);
	const machineId = props.machineId;
	const canCopyDescription = (row) => row.productionOrderNo != null &&
		row.productionOrderNo.toString() === activePO?.toString() && !!row.operationName?.trim();

	const saveDescriptionAsComment = async (prepend) => {
		if (savingComment || !commentOrder || !canCopyDescription(commentOrder)) return;
		setSavingComment(true);
		try {
			const machine = await fetchMachineData(machineId);
			const comment = prepend && machine.comment
				? `${commentOrder.operationName}\n${machine.comment}`
				: commentOrder.operationName;
			await patchMachineComment({ Id: machineId, comment, CommentCreatedBy: account?.username });
			setCommentOrder(null);
			queryClient.invalidateQueries(["machine", machineId]);
			props.invalidateMachineInfo?.();
			pushNotification(formatMessage(messages.po_comment_saved));
		} catch {
			pushErrorMessage(formatMessage(messages.po_comment_error));
		} finally {
			setSavingComment(false);
		}
	};

	const [openConfirmationStart, setOpenConfirmationStart] = useState(false);
	const [openConfirmationPause, setOpenConfirmationPause] = useState(false);
	const [openConfirmationStop, setOpenConfirmationStop] = useState(false);
	const [openSetCavity, setOpenSetCavity] = useState(false);
	const [cavities, setCavities] = useState("");
	const [cavityError, setCavityError] = useState(false);
	//const [orderNoToManipulate, setOrderNoToManipulate] = useState(null)
	const [orderToManipulate, setOrderToManipulate] = useState(null)
	const [disableButtons, setDisableButtons] = useState(false)

	const [activePO, setActivePO] = useState(null);
	const [selectedItemNo, setSelectedItemNo] = useState(null);

	const [activePOAction, setActivePOAction] = useState(null);
	const [openPopup, setOpenPopup] = useState(false);
	const [openReportPopup, setOpenReportPopup] = useState(false);
	const [openReportScrapPopup, setOpenReportScrapPopup] = useState(false);
	const apiRef = useGridApiRef();

	//####
	const itemNo = null; // Replace with the actual item number if available
	const showList = true;

	// useEffect(() => {
	// 	setActivePOAction("Start");
	// 	if (props.machineInfo && props.machineInfo.activeProductionOrder && props.reportPO) {
	// 		handleReportPOClick(props.machineInfo.activeProductionOrder);
	// 	}
	// }, []);

	///////////////////////////////////////////////////

	const [sortModelStorage, setSortModelStorage] = useState([
		{ field: "machineName", sort: "asc" }
	]);
	const [columnStorage, setColumnStorage] = useLocalStorage(
		"productionOrdersGridColumnStorage",
		{
			plannedStop: false,
			prioritySortOrder: false,
			plannedQty: false,
			reportedQty: false,
			remainingQty: false,
			uptime: false,
			downTime: false,
			scrappedQty: false,
			numberOfCyclesWithCavity: false,
		}
	);
	const [columnVisibilityModel, setColumnVisibilityModel] = useState(() => columnStorage);


	////////////////////////////////////////////////////////////////////////


	useEffect(() => {

		if (props.machineInfo && props.machineInfo.activeProductionOrder && props.reportPO) {

			console.log("[Debug] Report click in infoboxes:", props.machineInfo.activeProductionOrder, props.reportPO);

			props.setReportPO(false);
			if (isFeatureEnabled(props.featureFlags, 'UseProductionOrderTableAsPOMasterReportQty')) {
				console.log("[Debug] going to handleReportPOClick");
				handleReportPOClick(props.machineInfo.activeProductionOrder);
			}
			else if (isFeatureEnabled(props.featureFlags, 'UseProductionOrderTableAsPOMasterReportScrap')) {
				console.log("[Debug] going to handleReportScrapPOClick");
				handleReportScrapPOClick(props.machineInfo.activeProductionOrder);
			}
			setSelectedItemNo(props.machineInfo.activeItem);
		}
	}, [props.reportPO]);

	useEffect(() => {
		if (props.machineInfo && props.machineInfo.activeProductionOrder) {
			setActivePO(props.machineInfo.activeProductionOrder);
		}
	}, [props.machineInfo]);

	const productionOrdersQuery = useQuery(
		["productionorders", machineId, itemNo, companyKey],
		() => getProductionOrders(machineId, itemNo, companyKey),
		{}
	);

	// Keep only the most recently stopped order (statusId 3), placed first, plus all non-stopped orders as-is
	const gridRows = React.useMemo(() => {
		const data = productionOrdersQuery.data || [];
		const stopped = data.filter(po => po.statusId === 3 && po.endTime);
		const others = data.filter(po => po.statusId !== 3);

		if (stopped.length === 0) {
			return others;
		}

		const latestStopped = stopped.reduce((latest, po) =>
			new Date(po.endTime) > new Date(latest.endTime) ? po : latest
		);
		others.sort((a, b) => Date.parse(a.plannedStartTime) - Date.parse(b.plannedStartTime));
		others.sort((a, b) => a.priority - b.priority);

		return [latestStopped, ...others];
	}, [productionOrdersQuery.data]);

	const productionItemsQuery = useQuery(
		["productionitems", companyKey],
		() => fetchProductionItems(companyKey),
		{}
	);

	const producedByOrderNoQuery = useQuery(
		["producedbyorderno", props.machineInfo.activeProductionOrder, machineId, companyKey],
		() => getProducedByOrderNo(props.machineInfo.activeProductionOrder, machineId, companyKey),
		{}
	);

	const handleStartPO = (productionOrderNo) => {
		if (activePO && activePO !== productionOrderNo) {
			//alert(`Another production order (${activePO}) is already active. Please stop it before starting a new one.`);
			return;
		}
		setActivePO(productionOrderNo);
	}

	// Handle Report
	const handleReportPOClick = (po) => {

		//if po is not an object get object by po and machine
		// call comming from infoboxes might only provide the production order number, not the full object
		if (typeof po !== 'object') {
			po = gridRows.find(row => row.productionOrderNo === po);
		}

		setOrderToManipulate(po)
		//setOrderNoToManipulate(po.productionOrderNo)
		setOpenPopup(true);
		setOpenReportPopup(true);
	}

	// Handle Report Scrap
	const handleReportScrapPOClick = (po) => {

		//if po is not an object get object by po and machine
		// call comming from infoboxes might only provide the production order number, not the full object
		if (typeof po !== 'object') {
			po = gridRows.find(row => row.productionOrderNo === po);
		}
		setOrderToManipulate(po)
		//setOrderNoToManipulate(po.productionOrderNo)
		//setOpenPopup(true);
		setOpenReportScrapPopup(true);
	}

	// Handle stop
	const handleStopPOClick = (po) => {
		//setOrderNoToManipulate(po.productionOrderNo)
		setOrderToManipulate(po)
		setOpenConfirmationStop(true);
	}
	const handleStopPOOkClick = () => {
		setOpenConfirmationStop(false);
		//Delete and set status to 3-Stopped
		handleDeletePO(orderToManipulate);
	}
	const handleStopPOCancelClick = () => {
		setOpenConfirmationStop(false);
	}

	// Handle pause
	const handlePausePOClick = (po) => {
		//setOrderNoToManipulate(poNo)
		setOrderToManipulate(po);
		setOpenConfirmationPause(true);
	}
	const handlePausePOOkClick = () => {
		//Delete PO and update status to 4-paused
		setOpenConfirmationPause(false);
		handlePausePO(orderToManipulate);
		//setActivePO(null);
	}
	const handlePausePOCancelClick = () => {
		setOpenConfirmationPause(false);
	}

	// Handle start
	const handleStartPOClick = (po) => {
		//setOrderNoToManipulate(po.productionOrderNo)
		setOrderToManipulate(po);
		if (isFeatureEnabled(props.featureFlags, 'SetCavityOnStartOfPO')) {
			setCavities(po.cavities?.toString() || "1");
			setCavityError(false);
			setOpenSetCavity(true);
		} else {
			setOpenConfirmationStart(true);
		}

	}
	const handleStartPOOkClick = () => {
		setOpenConfirmationStart(false);
		// if (activePO && activePO !== productionOrderNo) {
		// 		//alert(`Another production order (${activePO}) is already active. Please stop it before starting a new one.`);
		// 		return;
		// 	}
		setActivePO(orderToManipulate.productionOrderNo);

		CreateActivePO(orderToManipulate);
	}
	const handleStartPOCancelClick = () => {
		setOpenConfirmationStart(false);
	}
	const handleSetCavityConfirm = () => {
		const parsedCavities = Number(cavities);

		if (!Number.isInteger(parsedCavities) || parsedCavities <= 0) {
			setCavityError(true);
			return;
		}

		const order = { ...orderToManipulate, cavities: parsedCavities };
		setOpenSetCavity(false);
		setActivePO(order.productionOrderNo);
		CreateActivePO(order);
	}
	const handleSetCavityCancel = () => {
		setOpenSetCavity(false);
	}

	const getRowClassName = (params) => {

		//console.log("[Debug] getRowClassName: params.row.productionOrderNo:", params.row.productionOrderNo, "activePO:", activePO);

		if (params.row.productionOrderNo?.toString() === activePO?.toString()) {
			return 'active-po-row';
		}
		if (params.row.statusId === 4) {
			return 'paused-po-row';
		}
		if (params.row.statusId === 3) {
			return 'stopped-po-row';
		}
		//return 'active-po-row';
		return '';
	};

	const setProdOrderStatus = (prodOrder, status) => {

		setDisableButtons(true);

		let po = {
			"productionOrderNo": prodOrder,
			"status": status,
			"companyKey": companyKey,
			"machineId": machineId
		}

		setProductionOrderStatus(po).then((result) => {

			// Stop
			if (po.status === "") {
				setActivePO(null);
			}
			// Pause
			if (po.status === "") {
				setActivePO("Pause");
			}
			//Start
			if (po.status === "") {
				setActivePO(po.productionOrderNo);
			}

			pushNotification(formatMessage(messages.po_message_updated));
			setDisableButtons(false);

			productionOrdersQuery.refetch();

			//setShowBackdrop(false);

		}).catch((error) => {
			console.log("Could not delete active production order", error);
			pushErrorMessage("Could not delete active production order: " + error?.message);
			setDisableButtons(false);
			//setShowBackdrop(false);
		});
	}

	// const xbuildOrderObject = () => {
	// 	// let order = [{
	// 	let activePO = productionOrdersQuery.data.find(po => po.productionOrderNo === orderNoToManipulate);

	// 	let remainingQTY = activePO.plannedQTY - activePO.reportedQTY;
	// 	if (isNaN(remainingQTY)) {
	// 		remainingQTY = 0;
	// 	}

	// 	let order = {
	// 		erpId: "x",
	// 		companyKey: companyKey.toString(),
	// 		machineId: activePO.machineId,
	// 		activeProductionOrderNumber: activePO.productionOrderNo,
	// 		activeTool: activePO.toolId?.toString() || "",
	// 		idealCycleTime: activePO.idealCycleTime,
	// 		plannedQuantity: activePO.plannedQTY,
	// 		reportedQuantity: activePO.reportedQTY,
	// 		remainingQuantity: remainingQTY,
	// 		activeItemId: activePO.itemNo,
	// 		cavities: activePO.cavities || 1,
	// 		activeProductionOrderIndex: 0,
	// 	};
	// 	// }];


	// 	return order;
	// }


	const buildOrderObject = (productionOrder) => {
		// let order = [{

		let remainingQTY = productionOrder.plannedQTY - productionOrder.reportedQTY;
		if (isNaN(remainingQTY)) {
			remainingQTY = 0;
		}

		return { ...productionOrder, remainingQTY: remainingQTY };
	}


	const CreateActivePO = (productionOrder) => {

		setDisableButtons(true);
		let order = buildOrderObject(productionOrder);

		createProductionOrderInSystem(order).then((result) => {
			// setShowBackdrop(false);
			setDisableButtons(false);
			// props.setOpenPopup(false);

			//pushNotification(formatMessage(messages.orderCreatedMessage));
			pushNotification(formatMessage(messages.po_message_started));

			productionOrdersQuery.refetch();
			// handleRefreshData();
			if (props.invalidateMachineInfo) {
				props.invalidateMachineInfo();
			}
		}).catch((error) => {
			console.log("Could not create active production order", error);
			pushErrorMessage(formatMessage(messages.po_message_created_error) + ": " + error?.message);
			// setShowBackdrop(false);
			setDisableButtons(false);
			// props.setOpenPopup(false);
		});
	}

	const handleDeletePO = (orderToManipulate) => {
		setDisableButtons(true);
		// setShowBackdrop(true);

		deleteProductionOrderInSystem(orderToManipulate).then((result) => {

			// setShowBackdrop(false);
			setDisableButtons(false);
			// props.setOpenPopup(false);

			//pushNotification(formatMessage(messages.orderDeletedMessage));
			pushNotification(formatMessage(messages.po_message_stopped));
			setActivePO(null);

			productionOrdersQuery.refetch();

			if (props.invalidateMachineInfo) {
				props.invalidateMachineInfo();
			}
		}).catch((error) => {
			console.log("Could not delete active production order", error);
			pushErrorMessage(formatMessage(messages.po_message_stopped_error) + ": " + error?.message);
			// setShowBackdrop(false);
			setDisableButtons(false);
		});
	}

	const handlePausePO = (orderToManipulate) => {
		setDisableButtons(true);
		// setShowBackdrop(true);

		console.log("[Debug] Pausing production order:", orderToManipulate);
		pauseProductionOrderInSystem(orderToManipulate).then((result) => {

			// setShowBackdrop(false);
			setDisableButtons(false);
			// props.setOpenPopup(false);

			//pushNotification(formatMessage(messages.orderDeletedMessage));
			pushNotification(formatMessage(messages.po_message_stopped));
			setActivePO(null);

			productionOrdersQuery.refetch();

			if (props.invalidateMachineInfo) {
				props.invalidateMachineInfo();
			}
		}).catch((error) => {
			console.log("Could not pause active production order", error);
			pushErrorMessage(formatMessage(messages.po_message_stopped_error) + ": " + error?.message);
			// setShowBackdrop(false);
			setDisableButtons(false);
		});
	}


	function getStatusDescription(status, rowPO) {
		switch (status) {
			case 1:
				return formatMessage(messages.po_status_planned);
			case 2:
				if (rowPO.productionOrderNo?.toString() === activePO?.toString()) {
					return formatMessage(messages.po_status_inprogress);
				}
				return formatMessage(messages.po_status_inprogress) + " (ERP)";
			case 3:
				return formatMessage(messages.po_status_completed);
			case 4:
				return formatMessage(messages.po_status_paused);
			default:
				return formatMessage(messages.po_status_unknown);
		}
	}

	function getProductionItemNameById(itemNo) {
		return productionItemsQuery.data?.find(item => item.itemNo === itemNo)?.name || "";
	}

	let columns = [
		{
			field: "reportNumber",
			headerName: formatMessage(messages.po_table_reportnumber),
			flex: 1,
			minWidth: 80
		},
		{
			field: "priority",
			headerName: "Prio", //formatMessage(messages.po_table_reportnumber),
			flex: 1,
			minWidth: 50
		},
		{
			field: "productionOrderNo",
			headerName: formatMessage(messages.po_table_productionordernumber),
			flex: 1,
			minWidth: 80
		},

		{
			field: "operationNumber",
			headerName: formatMessage(messages.po_table_operation),
			flex: 1,
			minWidth: 80
		},
		{
			field: "operationName",  //description
			headerName: formatMessage(messages.po_table_description),
			flex: 2,
			minWidth: 160,
			cellClassName: (params) => canCopyDescription(params.row) ? 'copy-description-cell' : '',
			renderCell: (params) => canCopyDescription(params.row) ? (
				<Box component="button" type="button" tabIndex={params.hasFocus ? 0 : -1}
					onClick={() => setCommentOrder(params.row)}
					aria-label={formatMessage(messages.po_comment_title)}
					disabled={savingComment}
					sx={{
						display: 'flex', alignItems: 'center', gap: 1, width: '100%', height: '100%',
						border: 0, p: 0, background: 'transparent', color: 'inherit', font: 'inherit',
						textAlign: 'left', cursor: 'pointer', minWidth: 0,
						'& .copy-description-icon': { visibility: 'hidden', ml: 'auto' },
						'&:hover .copy-description-icon, &:focus-visible .copy-description-icon': { visibility: 'visible' }
					}}>
					<Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{params.value}</Box>
					<ContentCopyIcon className="copy-description-icon" fontSize="small" />
				</Box>
			) : params.value
		},
		{
			field: "itemNo",
			headerName: formatMessage(messages.po_table_item),
			flex: 2,
			minWidth: 160,
			renderCell: (params) => `${(params.row.itemNo)} - ${getProductionItemNameById(params.row.itemNo)}`
		},
		// {
		// 	field: "itemNo",
		// 	headerName: "Item Name",
		// 	width: 150
		// },
		{
			field: "plannedStartTime",
			headerName: formatMessage(messages.po_table_plannedstarttime),
			flex: 2,
			minWidth: 120,
			renderCell: (params) => `${params.row.plannedStartTime.replace("T", " ")}`
		},
		{
			field: "plannedQTY",
			headerName: formatMessage(messages.po_table_plannedquantity),
			flex: 1,
			minWidth: 100,
			align: "right",
			headerAlign: "right",
			renderCell: (params) => `${Number(params.row.plannedQTY).toLocaleString("sv-SE")} ${params.row.unit || ""}`

		},
		// {
		// 	field: "producedQty",
		// 	headerName: formatMessage(messages.po_table_producedquantity),
		// 	flex: 1,
		// 	minWidth: 100,
		// 	align: "right",
		// 	headerAlign: "right",
		// 	renderCell: (params) => `${ params.row.productionOrderNo === props.machineInfo.activeProductionOrder ? Number(producedByOrderNoQuery?.data?.counterDiff || 0).toLocaleString("sv-SE") : "-"} ${params.row.unit || ""}`

		// },
		{
			field: "reportedQTY",
			headerName: formatMessage(messages.po_table_reportedquantity),
			flex: 1,
			minWidth: 100,
			align: "right",
			headerAlign: "right",
			renderCell: (params) => `${Number(params.row.reportedQTY).toLocaleString("sv-SE")} ${params.row.unit || ""}`
		},
		{
			field: "idealCycleTime",
			headerName: formatMessage(messages.po_table_idealcycletime),
			flex: 1,
			minWidth: 100,
			align: "right",
			headerAlign: "right",
			renderCell: (params) => {
				const value = Number(params.row.idealCycleTime);
				return Number.isFinite(value) ? value.toFixed(2) : "?";
			}
		},
		{
			field: "pace",
			headerName: formatMessage(messages.po_table_idealpace),
			flex: 1,
			minWidth: 100,
			align: "right",
			headerAlign: "right",
			renderCell: (params) => {
				// calculate and show pace pcs/hour
				const cycleTime = Number(params.row.idealCycleTime);
				if (cycleTime <= 0) {
					return "-";
				}
				const paceMultiplier = (isFeatureEnabled(props.featureFlags, 'ShowSpeedUnitType') && props.machine?.speedUnitType?.id === 5) ? 60 : 3600;
				const pace = paceMultiplier / cycleTime;
				return Number.isFinite(pace) && pace > 0 ? Math.round(pace).toFixed(0) : "-";
			}
		},
		{
			field: "toolId",
			headerName: formatMessage(messages.po_table_tool),
			flex: 1,
			minWidth: 100,
		},
		{
			field: "statusId",
			headerName: formatMessage(messages.po_table_status),
			align: "center",
			headerAlign: "center",
			flex: 1,
			minWidth: 100,
			renderCell: (params) => `${getStatusDescription(params.row.statusId, params.row)}` //(${params.row.statusId})
		},
		{
			field: "cavities",
			headerName: formatMessage(messages.po_table_cavity),
			align: "center",
			headerAlign: "center",
			flex: 1,
			minWidth: 100,
			renderCell: (params) => `${params.row.cavities || "-"}` //(${params.row.statusId})
		},
		{
			field: "actions",
			headerName: formatMessage(messages.po_table_actions),
			flex: 2,
			minWidth: 280,
			sortable: false,
			filterable: false,
			renderCell: (params) => (
				<Stack spacing="1px" direction="row">
					<Tooltip title={formatMessage(messages.startActiveProductionOrderTitle)} slotProps={{ tooltip: { sx: { fontSize: '12px', } } }}>
						<Box>
							<IconButton
								onClick={() => handleStartPOClick(params.row)}
								//Should be clickable if order is not running
								//disabled={params.row.productionOrderNo === activePO || activePO !== "#NA" || params.row.statusId === 3 || disableButtons} //params.row.productionOrderNo === activePO || activePO ||
								disabled={params.row.productionOrderNo === activePO || activePO !== "#NA" || disableButtons}
							>
								<PlayCircleFilledWhiteOutlinedIcon fontSize="large" />
							</IconButton>
						</Box>
					</Tooltip>
					<Tooltip title={formatMessage(messages.pauseActiveProductionOrderTitle)} slotProps={{ tooltip: { sx: { fontSize: '12px', } } }}>
						<Box>
							<IconButton
								onClick={() => handlePausePOClick(params.row)}
								disabled={params.row.productionOrderNo !== activePO || disableButtons}
							>
								<PauseCircleOutlineOutlinedIcon fontSize="large" />
							</IconButton>
						</Box>
					</Tooltip>
					<Tooltip title={formatMessage(messages.stopActiveProductionOrderTitle)} slotProps={{ tooltip: { sx: { fontSize: '12px', } } }}>
						<Box>
							<IconButton
								onClick={() => handleStopPOClick(params.row)}
								disabled={params.row.productionOrderNo !== activePO || disableButtons}
							>
								<StopCircleOutlinedIcon fontSize="large" />
							</IconButton>
						</Box>
					</Tooltip>
					{isFeatureEnabled(props.featureFlags, 'UseProductionOrderTableAsPOMasterReportQty') &&

						<Tooltip title={formatMessage(messages.reportActiveProductionOrderTitle)} slotProps={{ tooltip: { sx: { fontSize: '12px', } } }}>
							<Box>
								<IconButton
									onClick={() => { handleReportPOClick(params.row); setSelectedItemNo(params.row.itemNo) }}
									//disabled={params.row.productionOrderNo !== activePO || params.row.statusId !== 3 || disableButtons}
									disabled={!(params.row.productionOrderNo === activePO || params.row.statusId === 3) || disableButtons}
								>
									{/* <PlaylistAddOutlinedIcon fontSize="large" /> */}
									<MoveToInboxOutlinedIcon fontSize="large" />
								</IconButton>
							</Box>
						</Tooltip>

					}
					{isFeatureEnabled(props.featureFlags, 'UseProductionOrderTableAsPOMasterReportScrap') &&
						<Tooltip title={formatMessage(messages.reportScrapForActiveProductionOrderTitle)} slotProps={{ tooltip: { sx: { fontSize: '12px', } } }}>
							<Box>
								<IconButton
									onClick={() => handleReportScrapPOClick(params.row)}
									disabled={!(params.row.productionOrderNo === activePO || params.row.statusId === 3) || disableButtons}
								>
									<DeleteOutlinedIcon fontSize="large" />
								</IconButton>
							</Box>
						</Tooltip>
					}

				</Stack>
			)
		}
	];


	////////////////////////////////////
	const columnOrderLocalStorageName = 'ProductionOrders-columnOrder';
	const columnWidthsLocalStorageName = 'ProductionOrders-columnWidths';
	//const gridApi = useGridApiRef();

	// Load persisted column order, widths, and sort order on mount
	function initColumnsFromLocalStorage(columns) {
		let columnsToFix = columns;
		// Load column order
		const savedColumnOrder = localStorage.getItem(columnOrderLocalStorageName);
		if (savedColumnOrder) {
			const orderArray = JSON.parse(savedColumnOrder);
			columnsToFix = reorderColumns(orderArray, columnsToFix);
		}

		// Load column widths
		const savedWidths = localStorage.getItem(columnWidthsLocalStorageName);
		if (savedWidths) {
			const widthMap = JSON.parse(savedWidths);
			columnsToFix = applyColumnWidths(widthMap, columnsToFix);
		}
		return columnsToFix;
	};

	// Reorder columns based on saved order
	const reorderColumns = (orderArray, columnsToFix) => {
		const reorderedColumns = orderArray.map((field) =>
			columnsToFix.find((col) => col.field === field)
		);
		reorderedColumns.push(...columnsToFix.filter((col) => !reorderedColumns.includes(col)));
		return reorderedColumns;
	};

	// Apply saved column widths
	const applyColumnWidths = (widthMap, columnsToFix) => {
		const updatedColumns = columnsToFix.map((col) => ({
			...col,
			width: widthMap[col.field] || col.width,
			flex: widthMap[col.field] !== undefined ? undefined : col.flex,
		}));
		return updatedColumns;
	};

	// Handle column order change
	const handleColumnOrderChange = () => {
		if (!apiRef.current) {
			return;
		}
		const orderedColumns = apiRef.current.getVisibleColumns();
		const newColumnOrder = orderedColumns.map((col) => col.field);
		localStorage.setItem(columnOrderLocalStorageName, JSON.stringify(newColumnOrder));
	};

	// Handle column resize
	const handleColumnResize = (params) => {
		const { colDef, width } = params;
		const newWidths = JSON.parse(localStorage.getItem(columnWidthsLocalStorageName)) || {};
		newWidths[colDef.field] = width;
		localStorage.setItem(columnWidthsLocalStorageName, JSON.stringify(newWidths));
	};

	const saveState = (columnState) => {
		setColumnVisibilityModel(columnState);
		setColumnStorage(columnState);
	};


	////////////////////////////////////


	if (productionOrdersQuery === undefined || productionOrdersQuery.data === undefined || productionOrdersQuery.isLoading) {
		return <AxionControls.AxionBackdrop open={true} />
	}
	if (productionItemsQuery === undefined || productionItemsQuery.data === undefined || productionItemsQuery.isLoading) {
		return <AxionControls.AxionBackdrop open={true} />
	}
	if (producedByOrderNoQuery === undefined || producedByOrderNoQuery.data === undefined || producedByOrderNoQuery.isLoading) {
		return <AxionControls.AxionBackdrop open={true} />
	}

	columns = initColumnsFromLocalStorage(columns);

	//console.log("[Debug] producedByOrderNoQuery.data: ", producedByOrderNoQuery?.data);
	//console.log("[Debug] productionItemsQuery: ", productionItemsQuery);
	// console.log("[Debug] featureFlags: ", props.featureFlags);

	console.log("[Debug] gridRows: ", gridRows);

	return (
		<>
			<Dialog open={!!commentOrder} onClose={() => { if (!savingComment) setCommentOrder(null); }} maxWidth="sm" fullWidth
				PaperProps={{ sx: { backgroundColor: colors.primary[400], backgroundImage: 'none' } }}>
				<DialogTitle>{formatMessage(messages.po_comment_title)}</DialogTitle>
				<DialogContent dividers>
					<DialogContentText sx={{ color: 'text.primary' }}>{formatMessage(messages.po_comment_question)}</DialogContentText>
					<Typography sx={{ mt: 2, p: 2, backgroundColor: colors.primary[500], borderRadius: 1, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{commentOrder?.operationName}</Typography>
				</DialogContent>
				<DialogActions sx={{ p: 2, gap: 1, flexWrap: 'wrap' }}>
					<Controls.Button
						disabled={savingComment || !commentOrder || !canCopyDescription(commentOrder)}
						onClick={() => saveDescriptionAsComment(true)}
						text={formatMessage(messages.po_comment_prepend)}
						sx={{ backgroundColor: colors.axionGreen[500], color: theme.palette.common.white, '&:hover': { backgroundColor: darken(colors.axionGreen[500], 0.4) } }}
					/>
					<Controls.Button
						disabled={savingComment || !commentOrder || !canCopyDescription(commentOrder)}
						onClick={() => saveDescriptionAsComment(false)}
						text={formatMessage(messages.po_comment_replace)}
						sx={{ backgroundColor: colors.axionGreen[500], color: theme.palette.common.white, '&:hover': { backgroundColor: darken(colors.axionGreen[500], 0.4) } }}
					/>
					<Controls.Button
						disabled={savingComment}
						onClick={() => setCommentOrder(null)}
						text={formatMessage(messages.po_comment_cancel)}
						sx={{ backgroundColor: colors.redAccent[500], color: theme.palette.common.white, '&:hover': { backgroundColor: colors.redAccent[700] } }}
					/>
				</DialogActions>
			</Dialog>
			<Box width="100%" backgroundColor={colors.primary[400]} height={props.tabExpanded ? "69vh" : "50vh"}>

				{gridRows.length > 0 && showList && (
					<DataGridPro
						key={activePO}
						rows={gridRows}
						columns={columns}
						checkboxSelection={false}
						rowSelection={false}
						getRowClassName={getRowClassName}
						onCellClick={(params) => {
							if (params.field === 'operationName' && canCopyDescription(params.row) && !savingComment) {
								setCommentOrder(params.row);
							}
						}}

						apiRef={apiRef}
						onColumnResize={handleColumnResize}
						onColumnOrderChange={handleColumnOrderChange}
						sortModel={sortModelStorage}
						onSortModelChange={(newModel) => setSortModelStorage(newModel)}
						columnVisibilityModel={columnVisibilityModel}
						experimentalFeatures={{ newEditingApi: true }}
						onColumnVisibilityModelChange={saveState}

						width="100%"


						sx={{
							'& .copy-description-cell': { cursor: 'pointer' },
							'& .copy-description-cell:hover .copy-description-icon': { visibility: 'visible' },
							'& .MuiDataGrid-cell': {
								fontSize: '14px',
								borderBottom: '1px solid ' + colors.primary[500],
							},
							'& .MuiDataGrid-columnHeaders': {
								borderBottom: '1px solid ' + colors.primary[500],
							},
							'& .MuiDataGrid-columnHeaderTitle': {
								fontSize: '16px',
								whiteSpace: 'normal',
								lineHeight: 1.2,

								//fontWeight: 'bold',
							},
							'& .active-po-row': {
								backgroundColor: colors.axionGreen[500],
							},

							'& .active-po-row:hover': {
								backgroundColor: colors.axionGreen[600],
							},
							'& .paused-po-row': {
								backgroundColor: "#C7A84B", //colors.yellow[500]
							},
							'& .paused-po-row:hover': {
								backgroundColor: "#C7A84B", //colors.yellow[500]
							},
							'& .stopped-po-row': {
								backgroundColor: colors.redAccent[500], //"#C45747", //colors.yellow[500]
							},
							'& .stopped-po-row:hover': {
								backgroundColor: colors.redAccent[600], //colors.yellow[500]
							},
						}}
					/>)}
			</Box>

			<Popup
				openPopup={openReportPopup}
				setOpenPopup={setOpenReportPopup}
				maxWidht="sm"
				title={formatMessage(messages.po_reportqty_header) + " " + props.machineInfo.machineName + " - " + props.machineInfo.description}//{<FormattedMessage {...messages.importProductionItemLabel} />}
			>
				<ProductionOrderReport
					machineId={machineId}
					action={activePOAction}
					productionOrder={orderToManipulate}
					itemNo={selectedItemNo}
					setOpenPopup={setOpenReportPopup}
					invalidateMachineInfo={props.invalidateMachineInfo}
					producedByPO={producedByOrderNoQuery.data || []}
				//setShowBackdrop={setShowBackdrop}
				//handleRefreshData={activeProductionOrdersQuery.refetch}
				// machineInfo={props.machineInfo}
				// machine={props.machine}

				/>
			</Popup>

			<Popup
				openPopup={openReportScrapPopup}
				setOpenPopup={setOpenReportScrapPopup}
				maxWidht="sm"
				title={formatMessage(messages.po_reportscrap_header) + " " + props.machineInfo.machineName + " - " + props.machineInfo.description}//{<FormattedMessage {...messages.importProductionItemLabel} />}
			>
				<ProductionOrderReportScrap
					machineId={machineId}
					action={activePOAction}
					productionOrder={orderToManipulate}
					//setShowBackdrop={setShowBackdrop}
					//handleRefreshData={activeProductionOrdersQuery.refetch}
					setOpenPopup={setOpenReportScrapPopup}
					invalidateMachineInfo={props.invalidateMachineInfo}
				/>
			</Popup>

			<AxionControls.AxionConfirmation
				open={openConfirmationStart}
				title={formatMessage(messages.startProductionOrderTitle)}
				message={formatMessage(messages.startProductionOrderMessage)}
				onConfirm={handleStartPOOkClick}
				onCancel={handleStartPOCancelClick}
				cancelText={formatMessage(messages.no)}
				confirmText={formatMessage(messages.yes)}
			/>
			<Popup
				openPopup={openSetCavity}
				setOpenPopup={setOpenSetCavity}
				maxWidth="xs"
				title={formatMessage(messages.setCavityOnStartTitle)}
			>
				<Stack spacing={2}>
					<Typography>{formatMessage(messages.setCavityOnStartMessage)}</Typography>
					<TextField
						autoFocus
						error={cavityError}
						helperText={cavityError ? formatMessage(messages.setCavityOnStartInvalid) : ""}
						inputProps={{ min: 1, step: 1 }}
						label={formatMessage(messages.setCavityOnStartLabel)}
						onChange={(event) => {
							setCavities(event.target.value);
							setCavityError(false);
						}}
						type="number"
						value={cavities}
					/>
					<Stack direction="row" justifyContent="flex-end" spacing={1}>
						<Button
							variant="contained"
							onClick={handleSetCavityCancel}
							sx={{ marginLeft: "auto", marginTop: 0, width: "120px", height: "42px", backgroundColor: colors.redAccent[500] }}
						>
							<FormattedMessage {...messages.btnCancel} />
						</Button>
						<Button
							variant="contained"
							onClick={handleSetCavityConfirm}
							sx={{ marginLeft: "auto", marginTop: 0, width: "120px", height: "42px", backgroundColor: colors.axionGreen[500] }}
						>
							<FormattedMessage {...messages.btnStart} />
						</Button>
					</Stack>
				</Stack>
			</Popup>
			<AxionControls.AxionConfirmation
				open={openConfirmationPause}
				title={formatMessage(messages.pauseProductionOrderTitle)}
				message={formatMessage(messages.pauseProductionOrderMessage)}
				onConfirm={handlePausePOOkClick}
				onCancel={handlePausePOCancelClick}
				cancelText={formatMessage(messages.no)}
				confirmText={formatMessage(messages.yes)}
			/>
			<AxionControls.AxionConfirmation
				open={openConfirmationStop}
				title={formatMessage(messages.stopProductionOrderTitle)}
				message={formatMessage(messages.stopProductionOrderMessage)}
				onConfirm={handleStopPOOkClick}
				onCancel={handleStopPOCancelClick}
				cancelText={formatMessage(messages.no)}
				confirmText={formatMessage(messages.yes)}
			/>
		</>
	);


};
